import React, { useMemo } from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { HiDotsHorizontal } from "react-icons/hi";
import { CommunityProps } from "../../types";
import { hyundai } from "../../assets/images";
import {
  CreateCommunity,
  SkeletonElement,
  SkeletonSugestedCom,
  Tooltip,
} from "..";
import { ipfsGatewayImage } from "../../utils/ipfsGatewayImage";
import { Link } from "react-router-dom";
import useBodyScrollLock from "../../utils/useBodyScrollLock";

type SugestedCommunityProps = {
  communitiesNotMemberOf: CommunityProps[] | undefined;
  loading: boolean;
  community?: CommunityProps;
  isRefetching?: () => void;
};
const SugestedComunity: React.FC<SugestedCommunityProps> = ({
  communitiesNotMemberOf,
  loading,
  community,
  isRefetching,
}) => {
  const [active, setActive] = React.useState<number | null>(null);
  const [, setOpenOption] = React.useState(null);
  const [openCreate, setopenCreate] = React.useState(false);
  const [isLocked, toggle] = useBodyScrollLock();

  useMemo(() => {
    if (loading) {
      return (
        <div className="w-full sticky top-32 bg-white h-[300px] px-2 py-3">
          <div className="mb-3 ml-1 w-full">
            <SkeletonElement type="title" />
          </div>
          {[1, 2, 3, 4, 5].map((n) => (
            <SkeletonSugestedCom key={n} />
          ))}
        </div>
      );
    }
  }, [loading]);

  const handleToggle = (index: any) => {
    setOpenOption((prev) => (prev === index ? null : index));
  };

  const handleActive = (index: number) => {
    setActive(index);
  };

  const handleClose = () => {
    setopenCreate(false);
    if (typeof toggle === "function") {
      toggle();
    }
  };

  const handleOpen = () => {
    setopenCreate(true);
    if (typeof toggle === "function") {
      toggle();
    }
  };

  return (
    <div className="bg-white rounded shadow py-3 px-2 w-full flex flex-col h-[550px] sticky top-32">
      <div className="flex justify-between h-10 items-center mb-3">
        <h1 className="font-Poppins text-[9.1px] text-[#8E9297]">
          Sugested Communities
        </h1>
        <div
          className="w-6 h-6 items-center pl-[6px] flex rounded-full cursor-pointer bg-[rgba(33,87,89,0.05)]"
          onClick={handleOpen}
        >
          <Tooltip tooltip="create a community">
            <AiOutlinePlus size={12} className="fill-midGreen" />
          </Tooltip>{" "}
        </div>
      </div>
      <div className="flex flex-col gap-3 h-[calc(100%-4px)] overflow-y-auto rounded-sm">
        {communitiesNotMemberOf?.map((com, index) => {
          const totalMembers = com?.members?.length;

          return (
            <Link to={`/ecobook/community/${com.name}/${com.id}`} key={com.id}>
              <div
                className={`relative flex w-full items-center justify-between pr-2 cursor-pointer ${
                  active === index
                    ? "bg-midGreen h-9 transition-all rounded ease-linear duration-150"
                    : ""
                }`}
                key={com.id}
                onClick={() => handleActive(index)}
              >
                <div className="flex h-8 gap-2 items-center">
                  <div className="w-7 h-7 rounded-full">
                    {com.communityHeaderImgUrl ? (
                      <img
                        alt=""
                        src={ipfsGatewayImage(com.communityHeaderImgUrl)}
                        className={`w-7 h-7 rounded-full ${
                          active === index ? "ml-2 mb-px" : ""
                        }`}
                      />
                    ) : (
                      <img
                        alt=""
                        src={hyundai}
                        className={`w-7 h-7 rounded-full object-cover object-center ${
                          active === index ? "ml-2 mb-px" : ""
                        }`}
                      />
                    )}
                  </div>
                  <div className="flex flex-col justify-between">
                    <h4
                      className={`font-Poppins text-[12.5px] font-semibold ${
                        active === index ? "text-white" : "text-lightBlack"
                      }`}
                    >
                      {com?.name}
                    </h4>
                    <p
                      className={`font-Poppins font-normal text-[8px] details ${
                        active === index
                          ? "text-whiteMode"
                          : "text-lightGreyText"
                      }`}
                    >
                      {`${totalMembers} member${totalMembers > 1 ? "s" : ""}`}
                    </p>
                  </div>
                </div>
                <HiDotsHorizontal
                  size={13}
                  className={`${
                    active === index
                      ? "fill-white cursor-pointer"
                      : "fill-lightGreyText"
                  } `}
                  onClick={() => handleToggle(index)}
                />
                {/* {openOption === index && (
                <div className="absolute top-full right-[-20px] flex flex-col items-center">
                  <div className="border-l-[8px] w-[10px] border-r-[8px] border-l-transparent border-r-transparent border-b-[#000] border-b-[10px] border-solid"></div>
                  <ul
                    className='shadow bg-[#000] text-white mt-0 rounded whitespace-nowrap font-Poppins text-center justify-center text-xs'
                  >
                    <button className='p-3' type="button" onClick={handleJoin}>Join</button>
                  </ul>
                </div>
              )} */}
              </div>
            </Link>
          );
        })}
      </div>
      {openCreate && isLocked && (
        <CreateCommunity
          isRefetching={isRefetching}
          handleClose={handleClose}
          toggle={toggle}
        />
      )}
    </div>
  );
};

export default SugestedComunity;
